/*
(function ($) {

    $(document).ready(function () {
        $(".brand-list__heading").on("click", function(){
            if ($(window).width() < 992) {
                const openClass = "brand-list__heading--open";                
                const $children = $(this).nextUntil(".brand-list__heading");
                
                if ($(this).hasClass(openClass)) {
                    $children.removeClass("visible");
                    $(this).removeClass(openClass);
                } else {
                    $("." + openClass).removeClass(openClass).nextUntil(".brand-list__heading").removeClass("visible");
                    $children.addClass("visible");
                    $(this).addClass(openClass);

                    $("html, body").animate({
                        scrollTop: $("." + openClass).offset().top - 100
                    });
                }
            } 
        });
    });

})(jQuery);*/
